import Gateway from './gateway';
import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import {
    TCreateNewBranchAPIParams,
    TCreateNewRegionAPIParams,
    TGetAllBranchesAPIResponse,
    TGetAllRegionsAPIResponse,
    TGetBranchesChangeHistoryAPIParams,
    TGetBranchesChangeHistoryAPIResponse,
    TGetBranchListingAPIParams,
    TGetBranchListingAPIResponse,
    TGetRegionListingAPIParams,
    TGetRegionListingAPIResponse,
} from '~types/feat/branch';

export abstract class IBranchGateway extends Gateway {
    abstract getBranchListing(params: TGetBranchListingAPIParams): GatewayResponse<TGetBranchListingAPIResponse>;

    abstract getRegionListing(params: TGetRegionListingAPIParams): GatewayResponse<TGetRegionListingAPIResponse>;

    abstract createNewRegion(params: TCreateNewRegionAPIParams): GatewayResponse<null>;

    abstract createNewBranch(params: TCreateNewBranchAPIParams): GatewayResponse<null>;

    abstract getAllRegions(params: ProtectedRoute): GatewayResponse<TGetAllRegionsAPIResponse>;

    abstract getAllBranches(params: ProtectedRoute): GatewayResponse<TGetAllBranchesAPIResponse>;

    abstract getBranchesChangeHistoryListing(params: TGetBranchesChangeHistoryAPIParams): GatewayResponse<TGetBranchesChangeHistoryAPIResponse>;
}
